const featuredItems = [
  {
    tag: '爆',
    title: '顶流艺人恋情实锤曝光，深夜密会画面引全网热议',
    summary: '据多方消息源确认，某顶流艺人近期频繁出入某高档小区，疑似与新晋女星展开地下恋情。事件持续发酵中，粉丝群体反应激烈。',
    source: '51吃瓜独家',
    time: '3小时前',
    reads: '128.6万',
  },
  {
    tag: '热',
    title: '综艺录制现场突发争执，两位嘉宾当场翻脸离席',
    summary: '某热门综艺最新一期录制过程中发生意外冲突，两位常驻嘉宾因游戏环节产生激烈口角，导致录制中断近两小时。',
    source: '现场直击',
    time: '5小时前',
    reads: '96.3万',
  },
  {
    tag: '新',
    title: '年度51吃瓜大赛投票通道开启，候选名单引争议',
    summary: '第五届51吃瓜大赛正式启动，涵盖十大吃瓜类别。部分候选人入围资格引发网友质疑，主办方回应评选标准透明公正。',
    source: '官方发布',
    time: '8小时前',
    reads: '73.1万',
  },
  {
    tag: '爆',
    title: '知名导演新片片场事故，多家媒体争相报道内幕',
    summary: '某知名导演新片拍摄现场发生意外，导致拍摄进度严重滞后。剧组内部人士爆料事故原因并非官方通报所述，真相究竟如何？',
    source: '内幕追踪',
    time: '10小时前',
    reads: '61.8万',
  },
  {
    tag: '热',
    title: '女星婚变传闻再升级，社交平台删光合照引猜测',
    summary: '已婚女星被发现清空社交平台所有与丈夫的合影，同时取消关注。婚姻状况成谜，经纪人电话始终无人接听。',
    source: '娱记一线',
    time: '12小时前',
    reads: '55.2万',
  },
  {
    tag: '新',
    title: '选秀节目黑幕录音流出，节目组连夜发布声明',
    summary: '一段疑似选秀节目内部通话录音在网络疯传，内容涉及排名操纵和选手打压。节目组凌晨发布声明否认并称已报警处理。',
    source: '匿名爆料',
    time: '15小时前',
    reads: '42.7万',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点吃瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            今日最热吃瓜专题，为你精选全网最具话题性的娱乐八卦与实时爆料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-3">
                <span
                  className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-bold ${
                    item.tag === '爆'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '热'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400">{item.source}</span>
                <span className="ml-auto text-xs text-foreground-400">{item.time}</span>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-3">
                {item.summary}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.reads} 阅读
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  评论
                </span>
                <span className="flex items-center gap-1 ml-auto cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line"></i>
                  分享
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}